"use client";

import Image from "next/image";
import Link from "next/link";
import { Button, Typography } from "@material-tailwind/react";
import { motion } from "framer-motion";

function ProductIntro() {
  return (
    <section className="pt-25 lg:pt-0 pb-0 bg-[#eff6ff]">
      <div className="max-w-5xl mx-auto grid-cols-1 lg:grid-cols-2 gap-12 px-4">
        <header className="grid min-h-[49rem] bg-[#eff6ff]">
          <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 lg:items-center lg:gap-5">
            <motion.div
              className="lg:ml-8 text-center lg:text-left"
              initial={{ x: -100, opacity: 0 }} 
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: false, amount: 0.3 }}
            >
              <Typography {...({} as any)} variant="h1" className="mb-0 text-[#2998E2]">
                Rebott
              </Typography>
              <Typography {...({} as any)} as="h2" variant="h3" className="text-gray-800 text-[1.9rem] lg:text-[2.2rem] mb-1">
                ตู้คืนขวดพลาสติกอัจฉริยะ
              </Typography>
              <Typography {...({} as any)} 
                variant="lead"
                className="mb-4 text-md md:text-2xl lg:text-[19.3px] text-gray-800  md:pr-16 xl:pr-0"
              >
                ช่วยส่งเสริมการรีไซเคิล ทำให้สามารถลดขยะ <br/>และเกิดการแยกขวดพลาสติกอย่างมีประสิทธิภาพ <br/>พร้อมระบบสะสมแต้มและแลกของรางวัล
              </Typography>
              <Typography {...({} as any)} as="h3" variant="h4" 
                className="
                mb-5
                text-green-600
                font-semibold
                tracking-[0.02em]
                lg:tracking-[0.01em]
                text-lg   
                md:text-xl  
                lg:text-[21px] 
              "
              >
                “ทุกขวดที่คืนกลับมา ล้วนสร้างคุณค่าที่ยั่งยืน”
              </Typography>
                <div className="flex justify-center lg:justify-start">
                  <Link href="/#rebott-benefits" >
                    <Button {...({} as any)}  size="sm" className="px-6 text-md font-normal tracking-[0.04em] bg-[#2998E2] text-white hover:bg-[#2083c7]">
                      รู้จักตู้ <span className="capitalize">Rebott</span> มากขึ้น
                    </Button>
                  </Link>
                </div> 
            </motion.div>

            <motion.div
              className="mt-20 mb-2 lg:mb-2 lg:mb-0"
              initial={{ x: 100, opacity: 0 }} 
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
              viewport={{ once: false, amount: 0.3 }}
            >
              <div className="relative  w-full h-[500px] md:relative md:w-[500px] md:h-[600px]">
              <Image
                src="/image/ReBott_RVM.webp"
                // width={400}
                // height={500}
                fill 
                alt="Rebott ตู้คืนขวดพลาสติกอัจฉริยะ"
                priority
                fetchPriority="high"
                className=" object-contain"
              />
              </div>
            </motion.div>
          </div>
        </header>
      </div>
    </section>
  );
}

export default ProductIntro;